<template>
  <div id="app" class>
    <nav
      class="py-1 navbar font-weight-bold d-flex fixed-top navbar-success primary-bg-color"
    >
      <b-navbar-brand class="text-white brandHeight" to="/home" href="#">
        <span class="align-top d-inline-block">Rate Card Manager</span>
      </b-navbar-brand>
      <div v-if="$store.getters.isAuthenticated" class="float-right mr-1">
        <b-dropdown id="ddown1" class="m-md-2 active" ref="dropdownRef">
          <template v-slot:button-content>
            <font-awesome-icon
              class="text-white mr-1"
              :icon="['fas', 'user']"
              size="lg"
            />
            {{ $store.getters.user.name }}
          </template>
          <b-dropdown-item>
            <font-awesome-icon
              class="text-info mr-2"
              :icon="['fas', 'sign-out-alt']"
              size="lg"
            />
            <span @click="$store.getters.uaa.logout()" class="text-info"
              >Signout</span
            >
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </nav>
    <div class="py-2 container-fluid" style="margin-top: 60px">
      <router-view />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import security from "./utils/msalUtil";
import { EventBus } from "./EventBus";
export default {
  methods: {
    user() {
      this.$store.getters.user.name;
    },
  },
  mounted() {
    let that = this;
    EventBus.$on("toast", (msg) => {
      that.$bvToast.toast(msg.message, {
        title: msg.title,
        autoHideDelay: 3000,
        appendToast: true,
        solid: true,
        variant: msg.variant || "default",
      });
    });
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $primary-color;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.card {
  width: 70%;
}
label {
  color: #17a2b8;
}
.b-toaster-slot {
  top: 70px !important;
}
.hide {
  display: none;
}
svg {
  cursor: pointer;
}
.navbar {
  height: 62px;
}
.brandHeight {
  height: 36px;
}
</style>
